export default __webpack_public_path__ + "static/media/promo-spectrespecs_05.d2563e07.jpg";